import { getCookie } from './cookie'

const DEFAULT_FIELDS: readonly string[] = [
  'company_uuid',
  'company',
  'company_classification',
  'company_status',
  'company_shop',
  'company_coupon',
  'interfaceSettings',
  'signature',
  'company_origin',
  'company_id',
  'idGlobal',
  'company_dictionary',
  'distributor',
  'membership',
  'profilepic',
  'isAccountant',
  'registryDate',
]

/**
 * Fetches `/v1/users/self` and broadcasts the result via the
 * `load-user-self` CustomEvent for any legacy listener (e.g. the Pinia store
 * in `alegra_commons` during migration).
 *
 * The cookie name, API base URL, and HubSpot cookie name come from the bare
 * build-time identifiers `COOKIE_TOKEN`, `BASE_API_URL`, `CHAT_COOKIE` (see
 * `src/types.ts`). Each per-env CDN build bakes them in via rslib's
 * `source.define`; orchestrators load the CDN bundle for their environment
 * and get the right values automatically.
 */
export class UserSelfService {
  private getAuthToken(): string | undefined {
    return getCookie(COOKIE_TOKEN)
  }

  private getApiUrl(): string {
    const fields = [...DEFAULT_FIELDS]
    if (getCookie(CHAT_COOKIE)) {
      fields.push('hubspot')
    }
    return `${BASE_API_URL}v1/users/self?fields=${fields.join(',')}`
  }

  private dispatchUserSelfEvent(userData: Record<string, unknown>): void {
    const eventLoadUserSelf = new CustomEvent('load-user-self', { detail: userData })
    window._smileLayout ??= {}
    window._smileLayout.eventLoadUserSelf = eventLoadUserSelf
    window.dispatchEvent(eventLoadUserSelf)
  }

  public async load(): Promise<Record<string, unknown> | undefined> {
    try {
      const token = this.getAuthToken()
      if (!token) {
        console.warn('[alegra-commons-runtime] No auth token found, skipping load')
        return undefined
      }

      window._smileLayout ??= {}
      window._smileLayout.userPreloadActive = true

      const response = await fetch(this.getApiUrl(), {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
          'x-data-source': 'alegra-smile',
        },
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const userData = (await response.json()) as Record<string, unknown>
      this.dispatchUserSelfEvent(userData)
      return userData
    } catch (error) {
      console.warn('[alegra-commons-runtime] Error fetching user/self:', error)
      return undefined
    }
  }
}
